module.exports = __webpack_public_path__ + "img/icon-arrow arrow-down.877952cb.svg";